import AdapterJalali from '@date-io/date-fns-jalali';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';
import arySystemSettings from '../constants/arySystemSettings';
import useSystemSettingsContext from '../hooks/useSystemSettingsContext';

const AryDatePicker = ({
  renderInput,
  size,
  error,
  helperText,
  onBlur,
  allowFutureDates = false,
  autoFocus = false,
  maxDate = new Date(),
  minDate = null,
  iconSize = '1rem',
  tabIndex = 0,
  icon,
  ...others
}) => {
  const theme = useTheme();
  const { systemSettings } = useSystemSettingsContext();

  const StyledCalendarTodayOutlined = (props) => (
    <CalendarTodayOutlined style={{ fontSize: iconSize }} {...props} />
  );
  return (
    <LocalizationProvider
      dateAdapter={
        systemSettings?.[arySystemSettings?.isGregorian] || false
          ? AdapterDateFns
          : AdapterJalali
      }
    >
      <DatePicker
        mask={
          systemSettings?.[arySystemSettings?.isGregorian] || false
            ? ''
            : '____/__/__'
        }
        toolbarFormat="yyyy/MM/dd"
        inputFormat="yyyy/MM/dd"
        PaperProps={{
          style: {
            borderRadius: '4px',
            boxShadow:
              '0px 4px 14px 2px rgba(0, 0, 0, 0.12), 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 10px 1px rgba(0, 0, 0, 0.14)'
          }
        }}
        maxDate={allowFutureDates ? undefined : maxDate}
        minDate={minDate}
        componentsProps={{
          actionBar: { actions: [] }
        }}
        components={{
          OpenPickerIcon: StyledCalendarTodayOutlined
        }}
        closeOnSelect
        renderInput={
          renderInput ||
          ((params) => (
            <TextField
              // size={size}
              fullWidth
              helperText={helperText}
              onBlur={onBlur}
              autoFocus={autoFocus}
              sx={{
                '& label, & label.Mui-focused': {
                  color: error && theme.palette.error.main
                },
                '& .MuiFormHelperText-root': {
                  color: error && theme.palette.error.main
                },
                '&, &:hover': {
                  'fieldset.MuiOutlinedInput-notchedOutline': {
                    borderColor: error && theme.palette.error.main
                  }
                },
                '& .Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
                  borderColor: error && theme.palette.error.main
                },
                '& svg': { color: error && theme.palette.error.main },
                '& .Mui-focusVisible svg': {
                  color: theme.palette.primary.main,
                  backgroundColor: theme.wrapper.blueBackground.color
                }
              }}
              {...params}
              tabIndex={tabIndex}
            />
          ))
        }
        {...others}
      />
    </LocalizationProvider>
  );
};

export default AryDatePicker;
